module.exports = __webpack_public_path__ + "static/img/Logo-B.d5b03c3d.png";